import type { i18n as I18n } from 'i18next'
import App from './App'
import { I18nProvider } from './i18n'
import { AltContext, type AltMap } from './i18n/alt'

/** App with its i18n instance and the per-page locale availability map. Used by both the client and the prerenderer. */
export default function Root({ i18n, alt, url }: { i18n: I18n; alt: AltMap; url?: string }) {
  return <I18nProvider i18n={i18n}><AltContext.Provider value={alt}><App ssrUrl={url} /></AltContext.Provider></I18nProvider>
}
